import { all } from 'redux-saga/effects';
import { unfixedConcat } from '../../../utils';
import { sagas as businessSagas } from './business/sagas';
import { sagas as contentSagas } from './content/sagas';
import { sagas as teamSagas } from './team/sagas';
import { sagas as userSagas } from './user/sagas';

function* combinedBusinessSagas() {
  yield all(unfixedConcat(
    businessSagas,
    contentSagas,
    teamSagas,
    userSagas
  ));
}

export default combinedBusinessSagas;



// WEBPACK FOOTER //
// ./src/state/modules/business/sagas.js